define(["require", "exports", "jquery", "knockout", "log", "../../utils/tools", "../../utils/kendoUtils", "../../models/CommissionModel"], function (require, exports, $, ko, log, tools, KendoUtils, CommissionModel) {
    "use strict";
    var CommissionsImport = /** @class */ (function () {
        function CommissionsImport() {
            this.editModel = ko.observable(new CommissionModel());
            this.resulModel = ko.observable();
            this.hasResults = ko.observable(false);
            this.importFinished = ko.observable(false);
            this.officeLocations = [];
            this.lastError = "";
            this.isImportValid = false;
            this.tableRefreshInProgress = 0;
            this.bvnProviderId = 0;
            this.filteredStatuses = ko.observableArray([]);
            this.importData = [];
        }
        CommissionsImport.prototype.init = function () {
        };
        CommissionsImport.prototype.openImport = function (callback) {
            var self = this;
            self.resulModel = ko.observable();
            self.hasResults(false);
            self.importFinished(false);
            tools.editModal({
                title: "Supplier Commissions Import",
                buttonTitle: "Import",
                modalClass: "full-width no-padding",
                type: "info",
                modalOptions: {},
                save: function (event, modal) {
                    console.log('import commissions clicked');
                    //validate form
                    if (self.importData.length <= 0) {
                        tools.error("Data is empty");
                        return;
                    }
                    self.isImportValid = true;
                    ko.utils.arrayForEach(self.importData, function (item) {
                        if (!item.IsValid) {
                            self.isImportValid = false;
                            self.lastError = item.Error;
                        }
                    });
                    if (!self.isImportValid) {
                        tools.error(self.lastError ? self.lastError : "Some of import records are not valid");
                        return;
                    }
                    $(event.currentTarget).button('loading');
                    self.processNumbersImport(event.currentTarget, modal, callback);
                },
                opened: function (modal) {
                    self.importData = [];
                    // Get lookup data:
                    var getLookupData = tools.ajaxGet({
                        url: "/SupplierCommissions/ImportLookupData",
                        success: function (data) {
                            if (data.Success) {
                                self.lookupLists = data.Data.lookupLists;
                            }
                            else {
                                log.error(data.Error);
                            }
                        }
                    });
                    $.when(getLookupData).done(function (lookupData, data) {
                        $(modal).find(".modal-body").html("<div data-bind=\"template: { name: 'commissions-import-template', data: editModel }\"></div>");
                        ko.applyBindings(self, modal);
                        self.initImportGrid(self.lookupLists.GridStructures.CommissionsImportList);
                    });
                },
                onResize: function (height) {
                    setTimeout(function () {
                        self.importTable.fitHeightToParent(height - 127);
                    });
                }
            });
        };
        CommissionsImport.prototype.initImportGrid = function (gridStructure) {
            var self = this;
            var columns = gridStructure.columns;
            self.addEditActionColumn(columns);
            self.importTable = new KendoUtils.KendoUtils();
            var gridOptions = {
                dataSourceOptions: {
                    //data: self.importData,
                    transport: {
                        read: function (options) {
                            options.success(self.importData);
                        },
                        create: function (options) {
                            self.importData.push(options.data);
                            options.success(options.data);
                        },
                        update: function (options) {
                            var dataItem = ko.utils.arrayFirst(self.importData, function (item) {
                                return item.Id === options.data.Id;
                            });
                            if (dataItem) {
                                $.extend(dataItem, options.data);
                            }
                            options.success(options.data);
                        },
                        destroy: function (options) {
                            var dataRow = ko.utils.arrayFirst(self.importData, function (item) { return item.Id === options.data.Id; });
                            ko.utils.arrayRemoveItem(self.importData, dataRow);
                            options.success(options.data);
                        }
                    },
                    schema: {
                        model: gridStructure.model,
                        data: "",
                        total: function (result) {
                            result = result.data || result;
                            return result.length || 0;
                        }
                    },
                    serverFiltering: false,
                    serverPaging: false,
                    serverSorting: false
                },
                gridOptions: {
                    toolbar: kendo.template($("#commissions-import-toolbar").html()),
                    height: 500,
                    columns: columns,
                    dataBound: function (e) {
                        var dataItems = e.sender.dataSource.view();
                        for (var j = 0; j < dataItems.length; j++) {
                            var error = dataItems[j].get("Error");
                            if (error) {
                                var row = e.sender.tbody.find("[data-uid='" + dataItems[j].uid + "']");
                                row.addClass("alert-danger");
                            }
                        }
                    },
                    editable: {
                        mode: "inline"
                    },
                    save: function (e) {
                        //e.model.CommissionTotal = e.model.Rate ? e.model.ProductTotal * e.model.Rate : 0;
                        self.validateOneRecord(e.model);
                        setTimeout(function () {
                            e.sender.saveChanges();
                        }, 100);
                    },
                    remove: function (e) {
                        setTimeout(function () {
                            e.sender.saveChanges();
                        }, 100);
                    }
                },
                gridId: "importPreviewTable"
            };
            self.importTable.initGrid(gridOptions);
            setTimeout(function () {
                self.importTable.refresh();
            });
            $("#importPreviewTable").on("click", ".js-validate", function (event) {
                self.validateAllRecords();
                event.preventDefault();
            }).on("click", ".js-clear", function (event) {
                self.importData = [];
                event.preventDefault();
                self.importTable.refresh();
            });
            $("#importPreviewTable .k-grid-content").on("click", ".btn-remove", function (event) {
                KendoUtils.KendoUtils.removeGridRow(event.currentTarget);
                event.preventDefault();
            }).on("paste", function (event) {
                if ($('#importPreviewTable').find('.k-grid-edit-row').length) {
                    return true;
                }
                var pastedText = undefined;
                if (window["clipboardData"] && window["clipboardData"].getData) { // IE
                    pastedText = window["clipboardData"].getData("Text");
                }
                else if (event.originalEvent["clipboardData"] && event.originalEvent["clipboardData"].getData) {
                    pastedText = event.originalEvent["clipboardData"].getData("text/plain");
                }
                setTimeout(function () {
                    self.importData = [];
                    // the pasted content
                    var value = $.trim(pastedText);
                    // get the pasted rows - split the text by new line
                    var rows = value.split("\n");
                    var maxId = 0;
                    ko.utils.arrayForEach(self.importData, function (item) {
                        maxId = item.Id > maxId ? item.Id : maxId;
                    });
                    maxId++;
                    for (var i = 0; i < rows.length; i++) {
                        // get the cells - split by tab
                        var cells = rows[i].split("\t");
                        if (cells.length !== 7) {
                            tools.error("Data in clipboard is not valid");
                            break;
                        }
                        var rate = kendo.parseFloat(cells[5]) || 0;
                        var commissionTotal = kendo.parseFloat(cells[6]) || 0;
                        var productTotal = kendo.parseFloat(cells[4]) || 0;
                        self.addNewRecord({
                            Id: maxId++,
                            Error: "",
                            IsFlat: false,
                            IsValid: false,
                            SupplierName: cells[0],
                            PaidDate: kendo.parseDate(cells[1]),
                            CustomerName: cells[2],
                            ProductName: cells[3],
                            ProductTotal: productTotal,
                            Rate: rate,
                            CommissionTotal: commissionTotal
                        });
                    }
                    self.importTable.refresh();
                });
                return false; // Prevent the default handler from running.
            });
        };
        CommissionsImport.prototype.addEditActionColumn = function (columns) {
            var self = this;
            var actions = {
                field: "",
                command: ["edit", "destroy"],
                width: "86px"
            };
            columns.push(actions);
            //check custom editor
            var customEditors = {};
            /*customEditors["StatusEditor"] = (container, options) => {
    
                $('<input data-bind="value:' + options.field + '" name="' + options.field + '"/>')
                    .appendTo(container)
                    .kendoComboBox({
                        dataTextField: "Text",
                        dataValueField: "Text",
                        filter: "contains",
                        autoBind: true,
                        minLength: 1,
                        dataSource: {
                            data: self.filteredStatuses()
                        }
                    }).data("kendoComboBox");
            };
    
            customEditors["ProviderEditor"] = (container, options) => {
    
                $('<input data-bind="value:' + options.field + '" name="' + options.field + '"/>')
                    .appendTo(container)
                    .kendoComboBox({
                        dataTextField: "Text",
                        dataValueField: "Text",
                        filter: "contains",
                        autoBind: true,
                        minLength: 1,
                        dataSource: {
                            data: self.lookupLists.PhoneProviders
                        }
                    }).data("kendoComboBox");
            };
    
            customEditors["TypeEditor"] = (container, options) => {
    
                $('<input data-bind="value:' + options.field + '" name="' + options.field + '"/>')
                    .appendTo(container)
                    .kendoComboBox({
                        dataTextField: "Text",
                        dataValueField: "Text",
                        filter: "contains",
                        autoBind: true,
                        minLength: 1,
                        dataSource: {
                            data: self.lookupLists.PhoneTypes
                        }
                    }).data("kendoComboBox");
            };
    
            ko.utils.arrayForEach(columns, (column) => {
                if (column.hasOwnProperty("editor")) {
                    column["editor"] = customEditors[column["editor"]];
                }
            });*/
            return columns;
        };
        CommissionsImport.prototype.validateAllRecords = function () {
            var self = this;
            var dataGrid = self.importTable.getGridData();
            ko.utils.arrayForEach(self.importData, function (item) {
                self.validateOneRecord(item);
            });
            dataGrid.dataSource.read();
        };
        CommissionsImport.prototype.validateOneRecord = function (record) {
            var self = this;
            record.Error = "";
            var dataObject = {
                SupplierName: record.SupplierName,
                PaidDate: record.PaidDate,
                CustomerName: record.CustomerName,
                ProductName: record.ProductName,
                ProductTotal: record.ProductTotal,
                Rate: record.Rate,
                CommissionTotal: record.CommissionTotal
            };
            var forceReload = true;
            tools.ajaxPost({
                url: "/SupplierCommissions/ValidateCommissionRecord",
                data: tools.modelToFormData(dataObject)
            }).done(function (result) {
                if (result.Success) {
                    if (record.set) {
                        record.IsValid = result.Data.IsValid;
                        record.set("IsValid", result.Data.IsValid);
                        record.set("Error", result.Data.Errors.join("\n"));
                        forceReload = false;
                    }
                    else {
                        record.IsValid = result.Data.IsValid;
                        record.Error = result.Data.Errors.join("\n");
                    }
                }
                else {
                    tools.error(result.Error);
                }
            }).always(function () {
                if (self.tableRefreshInProgress) {
                    clearTimeout(self.tableRefreshInProgress);
                }
                if (forceReload) {
                    self.tableRefreshInProgress = setTimeout(function () {
                        self.importTable.refresh();
                    }, 100);
                }
            });
        };
        CommissionsImport.prototype.addNewRecord = function (record) {
            var self = this;
            self.validateOneRecord(record);
            // add a new item in the grid
            self.importData.push(record);
        };
        CommissionsImport.prototype.processNumbersImport = function (btn, modal, callback) {
            var self = this;
            self.hasResults(false);
            var data = {
                jsonData: ko.toJSON(self.importData)
            };
            tools.ajaxPost({
                url: "/SupplierCommissions/ImportCommissions",
                data: data
            }).done(function (result) {
                if (result.Success) {
                    self.resulModel(ko.mapping.fromJS(result.Data, {}));
                    if (callback) {
                        callback();
                    }
                    $(modal).modal('hide');
                    alert("Import finished successfully \n\nImported: ".concat(result.Data.ImportedRecords, "\nSkipped: ").concat(result.Data.NotValidRecords, " "));
                }
                else {
                    tools.error(result.Error);
                }
                self.hasResults(result.Success);
                log.log(result);
            }).always(function () {
                $(btn).button("reset");
                self.importFinished(true);
            });
        };
        return CommissionsImport;
    }());
    return CommissionsImport;
});
//# sourceMappingURL=commissionsImport.js.map


//////////////////
// WEBPACK FOOTER
// ./build/areas/commission/commissionsImport.js
// module id = 305
// module chunks = 2